module.exports = __webpack_public_path__ + "img/ico_defualt_pattern_02.87020ca3.png";